import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Popup from 'reactjs-popup';
import { Field } from 'formik';
import cn from 'classnames';

import PriceRangeField from '../../forms/price-range.field.js';

import MoneyIcon from '../../../assets/images/tour/ico_money.svg';

import './price.component.scss';

const PopupContent = ({ intl, minPrice, maxPrice }) => (
	<div className="popoverInner">
		<div className="popoverWrapper">
			<div className="row middle-xs price-range">
				<div className="col-xs-12 labels">
					{intl.formatMessage({ id: 'price-range.label' })}
				</div>
				<div className="col-xs-12 center-xs middle-xs range">
					<Field
						name="price"
						component={PriceRangeField}
						validate={value => (value.min > value.max
							? undefined
							: intl.formatMessage({ id: 'price-range.max-bigger-min' }))
						}
						minPrice={minPrice}
						maxPrice={maxPrice}
					/>
				</div>
			</div>
		</div>
	</div>
);

const PriceComponent = ({
	values, smallBar, intl, minPrice, maxPrice,
}) => (
	<div className={cn('price-range', { smallBar })}>
		<Popup
			trigger={(
				<div className="button row middle-xs">

					<div className="icon start-xs">
						{MoneyIcon && <img src={MoneyIcon} alt="price-icon" /> }
					</div>

					<div className="label ">

						{
							(values.price.min === minPrice && values.price.max === maxPrice)
							&& <FormattedMessage id="formik.price" />
						}

						{(values.price.min !== minPrice || values.price.max !== maxPrice) && `${values.price.min}€-${values.price.max}€` }
					</div>

					<div className="last-xs">
						<div className="icon">
							<svg
								height="20"
								width="20"
								viewBox="0 0 20 20"
								aria-hidden="true"
								focusable="false"
								className="css-19bqh2r"
							>
								<path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
							</svg>
						</div>
					</div>
				</div>
			)}
			position="bottom left"
			closeOnDocumentClick
			arrow={false}
			className={cn({ smallBar })}
		>
			<PopupContent
				intl={intl}
				price={values.price}
				minPrice={minPrice}
				maxPrice={maxPrice}
			/>
		</Popup>
	</div>
);

export default injectIntl(PriceComponent);
